import { useEffect } from "react";
import { useI18n } from "i18n";
import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import { useHistory } from "react-router";
import { PAGES, usePageTracking } from "modules/tracking";
import useCreateCompany from "../../hooks/useCreateCompany/useCreateCompany";

export const BackgroundCreateCompanyPage = (): JSX.Element => {
  const { t } = useI18n(["common"]);
  const { push } = useHistory();

  const {
    isLoading: isCompanyCreationLoading,
    isError: isCompanyCreationError,
  } = useCreateCompany();

  usePageTracking(PAGES.BACKGROUND_COMPANY_CREATE_PAGE);

  useEffect(() => {
    if (!isCompanyCreationLoading && !isCompanyCreationError) {
      push("/my-events");
    }
  }, [isCompanyCreationLoading, isCompanyCreationError, push]);

  return <PageLoader message={t("common:loading")} />;
};
